<script>
    import { ajaxIsCalling } from '/core/stores/ajaxLoader.js';    
</script>
{#if $ajaxIsCalling === true}

    <div class='loader-wrapper'>
        <div class="loader"></div>
    </div>

{/if}
<style>
    .loader-wrapper {
        z-index: 10;
        position:absolute;
        top:0;
        right:0;
        width: 60px;
        margin-right: 10px;
        margin-top: 26px;        
    }
    /* HTML: <div class="loader"></div> */
    .loader {
        width: 30px;
        aspect-ratio: 4;
        --_g: no-repeat radial-gradient(circle closest-side,#c7dddd 90%,#0000);
        background: 
            var(--_g) 0%   50%,
            var(--_g) 50%  50%,
            var(--_g) 100% 50%;
        background-size: calc(100%/3) 100%;
        animation: l7 1s infinite linear;
    }
    @keyframes l7 {
        33%{background-size:calc(100%/3) 0%  ,calc(100%/3) 100%,calc(100%/3) 100%}
        50%{background-size:calc(100%/3) 100%,calc(100%/3) 0%  ,calc(100%/3) 100%}
        66%{background-size:calc(100%/3) 100%,calc(100%/3) 100%,calc(100%/3) 0%  }
    }
</style>